import React, { useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import RegistrationPage from './pages/RegistrationPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import RegistrationManagementPage from './pages/RegistrationManagementPage';

function AppContent() {
  const [activePage, setActivePage] = useState('home');

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar activePage={activePage} setActivePage={setActivePage} />

      <main className="flex-1">
        {activePage === 'home' && <HomePage setActivePage={setActivePage} />}
        {activePage === 'register' && <RegistrationPage setActivePage={setActivePage} />}
        {activePage === 'login' && <LoginPage setActivePage={setActivePage} />}
        {activePage === 'dashboard' && <DashboardPage setActivePage={setActivePage} />}
        {activePage === 'management' && <RegistrationManagementPage setActivePage={setActivePage} />}
      </main>

      <footer className="bg-slate-900 text-slate-400 py-8 border-t border-slate-800 text-xs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-slate-200">User Authentication & Registration Management Prototype</p>
            <p className="mt-1">Built with React, Tailwind CSS, and LocalStorage persistence.</p>
          </div>
          <div className="flex items-center space-x-4">
            <button onClick={() => setActivePage('home')} className="hover:text-white transition-colors">Login Page</button>
            <button onClick={() => setActivePage('register')} className="hover:text-white transition-colors">Signup Page</button>
            <button onClick={() => setActivePage('management')} className="hover:text-white transition-colors">Reg Management</button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
